/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ProviderInputs */

const en_provider = /** @type {(inputs: ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Provider`)
};

const fr_provider = /** @type {(inputs: ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fournisseur`)
};

const de_provider = /** @type {(inputs: ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anbieter`)
};

const it_provider = /** @type {(inputs: ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fornitore`)
};

const ru_provider = /** @type {(inputs: ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поставщик`)
};

const es_provider = /** @type {(inputs: ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proveedor`)
};

const zh_cn2_provider = /** @type {(inputs: ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提供者`)
};

const ja_provider = /** @type {(inputs: ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロバイダー`)
};

const hi_provider = /** @type {(inputs: ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रदाता`)
};

const pt_pt2_provider = /** @type {(inputs: ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fornecedor`)
};

/**
* | output |
* | --- |
* | "Provider" |
*
* @param {ProviderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const provider = /** @type {((inputs?: ProviderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ProviderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_provider(inputs)
	if (locale === "de") return de_provider(inputs)
	if (locale === "it") return it_provider(inputs)
	if (locale === "ru") return ru_provider(inputs)
	if (locale === "es") return es_provider(inputs)
	if (locale === "zh-CN") return zh_cn2_provider(inputs)
	if (locale === "ja") return ja_provider(inputs)
	if (locale === "hi") return hi_provider(inputs)
	if (locale === "pt-PT") return pt_pt2_provider(inputs)
	return en_provider(inputs)
});